
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Popover } from 'element-ui';
import { namespace } from 'vuex-class';
import event from '@acgn/herm/src/util/event';

const ComicAction = namespace('desk/comic').Action;
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {
    [Popover.name]: Popover
  }
})

/**
 * 项目管理，画手工作台项目状态
 */
export default class AcgnLeftMenu extends Vue {
  @Prop() private isProject: any;

  @ComicAction private getProjectNum: any; // 创建漫画
  @CommGetter private attributeData: any; // 公共类型

  private activeSelect: any = 0;
  // 列表
  private proStadiusList: any = [
    {
      name: '进行中',
      num: 0
    },
    {
      name: '已完成',
      num: 0
    },
    {
      name: '已暂停',
      num: 0
    }
  ];

  // 刷洗项目状态
  private async refreshStatus() {
    const {result} = await this.getProjectNum({team_type: 0, is_creator: this.isProject ? 0 : 1 });
    this.proStadiusList[0].num = result.goCount;
    this.proStadiusList[1].num = result.overCount;
    this.proStadiusList[2].num = result.pauseCount;
    if (this.isProject) {
      this.proStadiusList[3].num = result.delCount;
    }
  }

  private created() {
    const cacheForm: any = this.$getFormCache();
    if (cacheForm.status) {
      this.activeSelect = cacheForm.status;
    }
    if (this.isProject) {
      this.proStadiusList.push({
        name: '已删除',
        num: 0
      });
    }
    this.refreshStatus();
    setTimeout(() => {
      // 绑定刷新列表事件
      event.on('$updateStatus', () => {
        this.refreshStatus();
      });
    }, 0);
  }

  private beforeDestroy() {
    event.off('$updateStatus');
  }

  // 点击
  private getSelect(index: any) {
    this.activeSelect = index;
    event.emit('$updateComicList', index === 3 ? -1 : index);
  }
}
